const state = {
  logged: false,
  username: '',
  nome: '',
  vinculo: '',
  administrador: false,
  usuarioPROEX: false,
  permissaoCriarProjetoExtensao: false
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/auth/state.js